import { apiRequest } from '.';

const GET_EXTERNAL_PREFERENCE_PATH = 'preference/external/get';
export const SET_EXTERNAL_PREFERENCE_PATH = 'preference/external/set';
const GET_PREFERENCE_PATH = 'preference/get';
const SET_PREFERENCE_PATH = 'preference/set';

type PreferenceType = 'user' | 'org' | 'contact';
type PreferenceData = unknown;
interface PreferenceResponse {
  status: string
  message: string
  data: PreferenceData
}

async function getCommon(path: string, type: PreferenceType, key: string): Promise<PreferenceData> {
  const fetchInit = {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  };

  const prefPathPrefix = (type === 'contact' ? 'jobseeker' : type);
  const response = await apiRequest(
    `/${prefPathPrefix}/${path}`,
    fetchInit,
    `pref_key=${key}`,
  );

  const preference = await response.json() as PreferenceResponse;

  return preference.data;
}

export async function getPreference(type: PreferenceType, key: string): Promise<PreferenceData> {
  return getCommon(GET_PREFERENCE_PATH, type, key);
}

export async function getExternalPreference(type: PreferenceType, key: string): Promise<PreferenceData> {
  return getCommon(GET_EXTERNAL_PREFERENCE_PATH, type, key);
}

async function setCommon(
  path: string, type: PreferenceType, key: string, value: string | number, expireSeconds?: string,
): Promise<PreferenceData> {
  const fetchInit = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: `pref_key=${key}&pref_value=${value}${expireSeconds ? `&expire_seconds=${expireSeconds}` : ''}`,
  };

  const prefPathPrefix = (type === 'contact' ? 'jobseeker' : type);
  const response = await apiRequest(
    `/${prefPathPrefix}/${path}`,
    fetchInit,
  );

  const preference = await response.json() as PreferenceResponse;

  return preference.data;
}

/**
 * @deprecated Use setExternalPreference instead.
 */
export async function setPreference(
  type: PreferenceType, key: string, value: string | number, expireSeconds?: string,
): Promise<PreferenceData> {
  return setCommon(SET_PREFERENCE_PATH, type, key, value, expireSeconds);
}


/**
 * Sets a persistent attribute for a logged-in user.
 * Make sure to add new attributes to app/lib/StarterView/Role/Controller/Preference.pm.
 */
export async function setExternalPreference(
  type: PreferenceType, key: string, value: string | number, expireSeconds?: string,
): Promise<PreferenceData> {
  return setCommon(SET_EXTERNAL_PREFERENCE_PATH, type, key, value, expireSeconds);
}
